import { Box } from '@mui/material';
import ReporListEdit from './ReporListEdit';

const ReportListSettings = () => {
  return (
    <Box p={2}>
      {/* <Typography variant="h4">Список отчетов</Typography> */}
      <ReporListEdit />
    </Box>
  );
};

export default ReportListSettings;
